"use client";

import React, { useLayoutEffect, useRef, useState } from "react";

import UserParticipationActions from "@/app/(main)/_club_components/user-participation-actions";
import useMobile from "@/hooks/use-mobile";
import { Club } from "@/TS/Interfaces/global_interfaces";

/** Barre sticky d'actions du club (fixed sous le header, ou en bas sur mobile). */
export default function UserParticipationButton({
  club,
  isLogged,
  presidentEmail,
  clubName,
}: {
  club: Club;
  isLogged: boolean;
  presidentEmail?: string | null;
  clubName?: string;
}) {
  const isMobile = useMobile();
  const [headerHeight, setHeaderHeight] = useState(0);
  const [barHeight, setBarHeight] = useState(0);
  const barRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const header = document.getElementById("header");
    if (!header) return;
    const stickyWrapper = header.parentElement ?? header;
    setHeaderHeight(stickyWrapper.offsetHeight);
    const observer = new ResizeObserver(() =>
      setHeaderHeight(stickyWrapper.offsetHeight),
    );
    observer.observe(stickyWrapper);
    return () => observer.disconnect();
  }, []);

  useLayoutEffect(() => {
    const bar = barRef.current;
    if (!bar) return;
    setBarHeight(bar.offsetHeight);
    const observer = new ResizeObserver(() => setBarHeight(bar.offsetHeight));
    observer.observe(bar);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div
        ref={barRef}
        className={`fixed z-[999] w-full bg-white border-separator-grey ${
          isMobile
            ? "bottom-0 border-t shadow-[0_-2px_8px_rgba(0,0,0,0.06)]"
            : "border-b shadow-[0_2px_8px_rgba(0,0,0,0.06)]"
        }`}
        style={isMobile ? undefined : { top: headerHeight }}
        role="region"
        aria-label="Actions principales du club"
      >
        <div
          className={`container mx-auto flex flex-col lg:flex-row items-center gap-3 py-3 px-4 lg:gap-4 lg:py-4 lg:px-6 ${
            clubName ? "lg:justify-between" : "lg:justify-center"
          }`}
        >
          {clubName && (
            <div className="hidden lg:block font-bold text-xl truncate">
              {clubName}
            </div>
          )}
          <UserParticipationActions
            club={club}
            isLogged={isLogged}
            presidentEmail={presidentEmail}
          />
        </div>
      </div>
      {!isMobile && (
        <div style={{ height: barHeight || 72 }} aria-hidden="true" />
      )}
    </>
  );
}
